/* GLobal translations */
import kk from './kk/ui.json';
import ru from './ru/ui.json';
import en from './en/ui.json';
import cn from './cn/ui.json';
/* Service Page:  */
/* Introduction */
import introKk from './kk/introduction.json';
import introRu from './ru/introduction.json';
import introEn from './en/introduction.json';
import introCn from './cn/introduction.json';

const locales = {
  kk: {
    ...kk,

    intro: introKk,
  },
  ru: {
    ...ru,

    intro: introRu,
  },

  en: {
    ...en,

    intro: introEn,
  },

  cn: {
    ...cn,

    intro: introCn,
  },
};

export default locales;
